import { createFileRoute, redirect } from '@tanstack/react-router';
import { breakpoints } from '@frontend/responsiveness';
import { HOME_DASHBOARD_PATH } from '../../paths';

type Search = {
  checkOnboarding?: boolean;
  locationIds?: string[] | undefined;
  orgId?: string | undefined;
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/home/apps')({
  beforeLoad: ({ search }) => {
    if (window.innerWidth > breakpoints.xsmall.max) {
      throw redirect({ to: HOME_DASHBOARD_PATH, search, replace: true });
    }
  },
  staticData: { team: 'fe-ux-platform' },
  validateSearch: (search: Search): Search => {
    return {
      ...search,
      checkOnboarding: search.checkOnboarding ? true : undefined,
      ...(search.orgId ? { orgId: search.orgId } : {}),
      ...(search.locationIds ? { locationIds: search.locationIds } : {}),
    };
  },
});
